import data from '@/api/data.js';
import {hierarchy} from 'd3-hierarchy';

const state = {
  dataSet: null,
  loadingDataset: true,
  authorsDataset: null,
  loadingAuthors: true,
  hierarchyData: null,
};

const mutations = {
  setDataset (state, value) {
    state.dataSet = value;
  },
  setDatasetLoader (state, value) {
    state.loadingDataset = value;
  },
  setAuthors (state, value) {
    state.authorsDataset = value;
  },
  setAuthorsLoader (state, value) {
    state.loadingAuthors = value;
  },
  setHierarchyData (state, value) {
    state.hierarchyData = hierarchy (value);
  },
};

const getters = {
  getDataSet: state => state.dataSet,
  isDatasetLoading: state => state.loadingDataset,
  getAuthors: state => state.authorsDataset,
  areAuthorsLoading: state => state.loadingAuthors,
  hierarchyData: state => state.hierarchyData,
};

const actions = {
  setDataset({commit}, value) {
    commit ('setDatasetLoader', true);
    data.getDataSet (value).then (d => {
      commit ('setDataset', d);
      commit ('setDatasetLoader', false);
      commit ('setHierarchyData', d);
    });
  },
  setAuthors({commit}, value) {
    commit ('setAuthorsLoader', true);
    data.getAuthorsDataSet (value).then (d => {
      commit ('setAuthors', d);
      commit ('setAuthorsLoader', false);
    });
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
